import { Base64 } from 'js-base64';
import { EComService } from './ecom-common.service';
import { Injectable, OnInit, OnDestroy } from '@angular/core';
@Injectable()
export class EcomCookies {

  constructor(private servie: EComService) {

  }

  private cookieExpiryInDays = 365;

  get cookie_user_location(): any {
    return this.getCookie('userlocation');
  }
  set cookie_user_location(value) {
    this.setCookieInDays('userlocation', value, this.cookieExpiryInDays);
  }

  get cookie_address_place_id(): any {
    return this.getCookie('place_id');
  }
  set cookie_address_place_id(value) {
    this.setCookieInDays('place_id', value, this.cookieExpiryInDays);
  }

  get cookie_address_change_place_id(): any {
    return this.getCookie('change_place_id');
  }
  set cookie_address_change_place_id(value) {
    this.setCookieInDays('change_place_id', value, this.cookieExpiryInDays);
  }


  get cookie_latlng(): any {
    return this.getCookie('latlng');
  }
  set cookie_latlng(value) {
    this.setCookieInDays('latlng', value, this.cookieExpiryInDays);
  }

  get cookie_latlng_delivery_address_change(): any {
    return this.getCookie('latlng_delivery_address_change');
  }
  set cookie_latlng_delivery_address_change(value) {
    this.setCookieInDays('latlng_delivery_address_change', value, this.cookieExpiryInDays);
  }

  get cookie_country_code(): any {
    return this.getCookie('countrycode');
  }
  set cookie_country_code(value) {
    this.setCookieInDays('countrycode', value, this.cookieExpiryInDays);
  }

  get cookie_usercity(): any {
    return this.getCookie('city');
  }

  set cookie_usercity(value) {
    this.setCookieInDays('city', value, this.cookieExpiryInDays);
  }

  get cookie_pincode(): any {
    return this.getCookie('pin');
  }

  set cookie_pincode(value) {
    this.setCookieInDays('pin', value, this.cookieExpiryInDays);
  }

  get cookie_authtoken(): any {
    return this.getCookie('authtoken');
  }
  set cookie_authtoken(value) {
    this.setCookie('authtoken', value);
  }

  get cookie_checkout_name(): any {
    return this.getCookie('co_name');
  }
  set cookie_checkout_name(value) {
    this.setCookie('co_name', value);
  }

  get cookie_checkout_dialcode(): any {
    return this.getCookie('co_dialcode');
  }
  set cookie_checkout_dialcode(value) {
    this.setCookie('co_dialcode', value);
  }

  get cookie_checkout_phone(): any {
    return this.getCookie('co_number');
  }
  set cookie_checkout_phone(value) {
    this.setCookie('co_number', value);
  }

  get cookie_checkout_address(): any {
    return this.getCookie('co_address');
  }
  set cookie_checkout_address(value) {
    this.setCookie('co_address', value);
  }

  get cookie_checkout_landmark(): any {
    return this.getCookie('co_landmark');
  }
  set cookie_checkout_landmark(value) {
    this.setCookie('co_landmark', value);
  }

  get cookie_checkout_city(): any {
    return this.getCookie('co_city');
  }
  set cookie_checkout_city(value) {
    this.setCookie('co_city', value);
  }

  get cookie_checkout_pincode(): any {
    return this.getCookie('co_pin');
  }
  set cookie_checkout_pincode(value) {
    this.setCookie('co_pin', value);
  }

  get cookie_checkout_distance(): any {
    return this.getCookie('co_distance');
  }
  set cookie_checkout_distance(value) {
    this.setCookie('co_distance', value);
  }

  get cookie_checkout_deliverycharges(): any {
    return this.getCookie('co_deliverycharges');
  }
  set cookie_checkout_deliverycharges(value) {
    this.setCookie('co_deliverycharges', value);
  }


  get cookie_user_phone(): any {
    return this.getCookie('user_phone');
  }
  set cookie_user_phone(value) {
    this.setCookie('user_phone', value);
  }

  get cookie_user_country_code(): any {
    return this.getCookie('user_country_code');
  }
  set cookie_user_country_code(value) {
    this.setCookie('user_country_code', value);
  }


  setCookie(cname, cvalue) {
    const expires = ';expires=Fri, 31 Dec 9999 23:59:59 GMT';
    if (cvalue) {
      cvalue = Base64.encode(cvalue);
    }
    document.cookie = this.servie.GetOlarConfigValue('cookiename') + cname + '=' + (cvalue || '') + expires + '; path=/';
  }

  setCookieInHours(cname, cvalue, exhours) {
    let expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + (exhours * 60 * 60 * 1000));
    const expires = ';expires=' + expiryDate['toGMTString']();
    if (cvalue) {
      cvalue = Base64.encode(cvalue);
    }
    document.cookie = this.servie.GetOlarConfigValue('cookiename') + cname + '=' + (cvalue || '') + expires + '; path=/';
  }

  setCookieInDays(cname, cvalue, exDays) {
    let expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + (exDays * 24 * 60 * 60 * 1000));
    const expires = ';expires=' + expiryDate['toGMTString']();
    if (cvalue) {
      cvalue = Base64.encode(cvalue);
    }
    document.cookie = this.servie.GetOlarConfigValue('cookiename') + cname + '=' + (cvalue || '') + expires + '; path=/';
  }

  setCookieInMinutes(cname, cvalue, exmins) {
    let expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + (exmins * 60 * 1000));
    const expires = ';expires=' + expiryDate['toGMTString']();
    if (cvalue) {
      cvalue = Base64.encode(cvalue);
    }
    //cvalue = cvalue.replace(/[, ]+/g, " ").trim();
    document.cookie = this.servie.GetOlarConfigValue('cookiename') + cname + '=' + (cvalue || '') + expires + '; path=/';
  }

  getCookie(cname) {
    var name = this.servie.GetOlarConfigValue('cookiename') + cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        let str = c.substring(name.length, c.length);
        if (str) {
          str = Base64.decode(str);
        }
        return str;
      }
    }
    return "";
  }

  delete_cookie(cname): boolean {
    cname = this.servie.GetOlarConfigValue('cookiename') + cname;
    document.cookie = cname + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    //this.cookieService.delete(cname);
    return true;
  }

  deleteCheckoutCookies() {
    this.delete_cookie('change_place_id');
    this.delete_cookie('latlng_delivery_address_change');
    this.delete_cookie('co_address');
    this.delete_cookie('co_landmark');
    this.delete_cookie('co_city');
    this.delete_cookie('co_pin');
    this.delete_cookie('co_distance');
    this.delete_cookie('co_deliverycharges');
  }

  
}
